import { useGetPractitionerRoles } from '@screens/PractitionerScreen/components/PractitionerCard/helper'
import { ReactNode } from 'react'
import { useGetTreatmentInfo } from './useGetTreatmentInfo'
import { useTranslation } from 'react-i18next'
import { useLanguage } from './useLanguage'

const usePractitionerData = () => {
  const { t } = useTranslation()
  const { practitioner, allPractitioners, selectedPractitionerIds, isLoading } = useGetTreatmentInfo()
  const language = useLanguage()

  const practitionerRole = useGetPractitionerRoles(
    practitioner?.positions,
    practitioner?.gender,
    practitioner?.displayRole,
    language
  )

  const allPractitionersLength = allPractitioners?.length || 0
  const selectedPractitionerIdsLength = selectedPractitionerIds?.length || 0
  const allPractitionersSelected = allPractitionersLength === selectedPractitionerIdsLength
  const multiplePractitionersSelected =
    allPractitionersLength > 0 && selectedPractitionerIdsLength > 0 && !allPractitionersSelected
  const hasRecommendedPractitioner = !!practitioner

  let practitionerDetailsFirstLine = ''
  let practitionerDetailsSecondLine: ReactNode = ''

  if (hasRecommendedPractitioner) {
    practitionerDetailsFirstLine = practitioner?.name || ''
    practitionerDetailsSecondLine = practitionerRole
  } else if (allPractitionersSelected) {
    practitionerDetailsFirstLine = t('selected_practitioners_all')
    practitionerDetailsSecondLine = t('showing_all_slots')
  } else if (multiplePractitionersSelected) {
    practitionerDetailsFirstLine = t('selected_practitioners_multiple')
  } else {
    practitionerDetailsFirstLine = t('selected_practitioners_all')
    practitionerDetailsSecondLine = t('showing_all_slots')
  }

  return {
    practitioner,
    practitionerDetailsFirstLine,
    practitionerDetailsSecondLine,
    hasRecommendedPractitioner,
    imageUrl: practitioner?.imageUrl,
    isPractitionerDataLoading: isLoading,
  }
}

export default usePractitionerData
